import colors from './colors';
const { skyDarkest, errorRed } = colors;
export const fonts = {
    black: "'Avenir'",
    medium: "'Avenir'",
    light: "'Avenir'",
    primary: 'avenir',
    fallback: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
};
export const fontWeights = {
    light: '300',
    medium: '500',
    bold: '750',
};
export const outlines = {
    focus: `2px solid ${skyDarkest}`,
    error: `2px solid ${errorRed}`,
};
export const radii = {
    default: '5px',
};
export const zIndices = {
    page: {
        title: 10,
    },
    sidebar: {
        backdrop: 20,
        shell: 21,
        navigation: 22,
    },
    drawer: 30,
    modal: 40,
    dropdown: 50,
    notification: 90,
    tooltip: 100,
};
export const heights = {
    header: '58px',
    menuIcon: '20px',
};
